export default "__VITE_ASSET__DuW6B0XT__"